<template>
  <div>
    <layout-content>
      <v-tabs
        class="mb-5"
        v-model="tab"
        align-with-title
        :value="$route.params.type"
      >
        <v-tabs-slider color="#394858" />
        <v-tab
          class="ml-5"
          active-class="tab-active"
          key="general"
          name="general"
          :value="$route.params.type"
          @click="$router.push( 'general' )"
        >
          {{ $t(`shared.breadcrumb.stats.general`)}}
        </v-tab>
        <v-tab
          active-class="tab-active"
          v-for="item in tabs"
          :key="item"
          :value="item"
          @click="$router.push( item )"
        >
          {{ item }}
        </v-tab>
      </v-tabs>
      <div v-if="$route.params.type == 'general'">
        <stats-filter />
        <stats-chart v-show="is_visible" />
        <stats-general />
      </div>
      <div v-else>
        <v-progress-circular
          v-if="!loaded"
          :size="50"
          :width="5"
          color="#5389fa"
          indeterminate
        />
        <iframe 
          width="100%" 
          :style="height[$route.params.type] ? `height: ${height[$route.params.type]}px` : 'height: calc(100vh - 305px)'"
          :src="url[$route.params.type]"
          @load="load"
          frameborder="0"
        >
        </iframe>
      </div>
    </layout-content>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import StatsGeneral from '@stats/components/stats-general'
  import StatsFilter from '@stats/components/stats-detailed-table-filter'
  import StatsChart from '@stats/components/stats-general-chart-main'
  import { DataStudioService } from '@administration/services/DataStudioService';
  export default {
    components: {
      StatsGeneral,
      StatsFilter,
      StatsChart
      // 'stats-general': () => import('@stats/components/stats-general'),
      // 'stats-detailed': () => import('@stats/components/stats-detailed')
    },
    data() {
      return {
        tabs: [],
        url: {},
        height: {},
        loaded: false,
        tab: null
      }
    },
    computed: {
      ...mapGetters('stats/table', ['data']),
      is_visible() {
        if(this.data) {
          return this.data.length
        }
        return 0
      }
    },
    mounted() {
      console.log(this.$route.params.type)
    },
    watch: {
      '$route.params.type': {
        handler: function() {
          this.add_breadcumbs({
            item: {
              title: `shared.breadcrumb.stats.${this.$route.params.type}`,
              route: {
                name: 'stats.type',
                params: { type: this.$route.params.type }
              }
            }
          });
        },

        immediate: true
      }
    },
    created() {
      DataStudioService.getList().then(data => data.data.forEach(e => {
        this.url[e.name] = e.url
        this.height[e.name] = e.height
        this.tabs.push(e.name);
      }))
    },
    methods: {
      ...mapActions('shared/breadcrumbs', { add_breadcumbs: 'add_item' }),
      load() {
        this.loaded  = true
      }
    }
  };
</script>

<style lang="scss" scoped>
  .v-progress-circular {
    width: 140px;
    height: 140px;
    position: absolute;
    top: calc(50% - 25px);
    left: calc(50% - 25px);
  }
  .tab-active {
    color: #515A6E;
  }
</style>